import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";

const useFirebaseEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === "true";
const emulatorHost = process.env.REACT_APP_FIREBASE_EMULATOR_HOST || "127.0.0.1";
const emulatorProjectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || "demo-innaim-local";

const productionFirebaseConfig = {
    // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain: process.env.REACT_APP_authDomain,
    // projectId: process.env.REACT_APP_projectId,
    // storageBucket: process.env.REACT_APP_storageBucket,
    // messagingSenderId: process.env.REACT_APP_messagingSenderId,
    // appId: process.env.REACT_APP_appId,
    // measurementId: process.env.REACT_APP_measurementId

    apiKey: "AIzaSyDDZdDAf9YMFARpla7TzV_346SLiM6DAp8",
    authDomain: "hivits-app.firebaseapp.com",
    projectId: "hivits-app",
    storageBucket: "hivits-app.firebasestorage.app",
    messagingSenderId: "1020133198552",
    appId: "1:1020133198552:web:bcb09c036fb703a6dd25ad",
    measurementId: "G-16ND8MYHWP",
};

const firebaseConfig = useFirebaseEmulators
    ? {
        ...productionFirebaseConfig,
        authDomain: `${emulatorProjectId}.firebaseapp.com`,
        projectId: emulatorProjectId,
        storageBucket: `${emulatorProjectId}.appspot.com`,
    }
    : productionFirebaseConfig;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const functions = getFunctions(app);
const storage = getStorage(app);
const db = getFirestore(app);

if (useFirebaseEmulators) {
    connectFunctionsEmulator(functions, emulatorHost, 5001);
    connectAuthEmulator(auth, `http://${emulatorHost}:9099`, { disableWarnings: true });
    connectFirestoreEmulator(db, emulatorHost, 8080);
    connectStorageEmulator(storage, emulatorHost, 9199);
}

auth.languageCode = "ko";

export default app;
export { auth, functions, storage, db };
